import { useEffect, useMemo, useState } from 'react';
import '../../../styles.scss';
import { Tabs, Pagination, ConfigProvider, PaginationProps } from 'antd';

import { SettingOutlined, EyeOutlined, EditOutlined } from '@ant-design/icons';
import { TabsProps } from 'antd/lib';
import { AgGridReact } from 'ag-grid-react';
import { NodataTable } from '../../../../../components/NoDataTable';
import { formatNumber } from '../../../../../services/mixin';
import viVN from "antd/locale/vi_VN";
import { FlattenedField } from '../../../../CustomersV2/indexV2';
import { FieldsUpdate, getInfoQuestionSurvey, getListCustomerSurvey, getListFieldsByCustomer, ICustomer, IInfoSurvey, IQuestionSurvey, ListField, updateFieldUser } from '../../../../../api/Customer_V2/customerApi_V2';
import { IPagination } from '../../../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup';
import { ColumnKey } from '../../../../Customers/Tabs/CarListCardClone';
import useLoading from '../../../../../hook/useLoading';
import useToast from '../../../../../hook/useToast';
import { useSelector } from 'react-redux';
import { selectorCategoryCarIds } from '../../../../../store/slices/categoryCarSlice';
import { selectorInfoUser } from '../../../../../store/slices/infoUserSlice';
import { generateColumnsFromCodesAgGridReactRecordCar } from '../../ServiceRecords/ContactInformation';
import useDebounce from '../../../../../hook/useDebounce';
import { CustomLoadingOverlayTable, dataPagination, flattenFields } from '../../../../../until';
import ServiceRecordFeilds from '../../ServiceRecords/Components/ServiceRecordFeilds';
import TabSurveyInformationTabDetail from './Components/TabSurveyInformationTabDetail';
import ModalSurveyInformationAdd from '../TabInvoiceHistory/Components/ModalSurveyInformationAdd';
import { FIELDTYPE, NO_VIEW } from '../../../../../services/data';
import { ColDef } from 'ag-grid-community';
import useThrottle from '../../../../../hook/useThrottle';
import ModalSurveyInformationDetail from '../TabInvoiceHistory/Components/ModalSurveyInformationDetail';
import ModalSurveyInformationUpdate from '../TabInvoiceHistory/Components/ModalSurveyInformationUpdate';

type PaginationKey = "info";
interface IDataFilterActive {
  info: FlattenedField[];
}

interface IDataFilterNoActive {
  info: ListField[];
}

const EMPTY_GROUP = {
  info: [],
};

interface Props {
  loadingTable: boolean
  isModalModalSurveyInformationDetail: boolean
  isModalModalSurveyInformationAdd: boolean
  isModalModalSurveyInformationUpdate: boolean

  dataFieldsActive: FlattenedField[]
  idCustomer?: number
  infoSurveyInformationDetail?: IInfoSurvey
  data: ICustomer[]
  pagination: IPagination

  setIsModalSurveyInformationDetail: (e: boolean) => void
  setIsModalSurveyInformationAdd: (e: boolean) => void
  setIsModalModalSurveyInformationUpdate: (e: boolean) => void

  onPaginationChange: (page: number, pageSize: number) => void
  resultFormSubmitSurveyInformation?: (iSsuccess: boolean, message?: string) => void
  openModalUpdate: (value: number) => void

}

const TabSurveyInformation: React.FC<Props> = ({
  loadingTable,
  isModalModalSurveyInformationDetail,
  isModalModalSurveyInformationAdd,
  isModalModalSurveyInformationUpdate,

  dataFieldsActive, pagination,
  idCustomer, infoSurveyInformationDetail, data,

  setIsModalSurveyInformationDetail,
  setIsModalSurveyInformationAdd,
  setIsModalModalSurveyInformationUpdate,

  onPaginationChange,
  resultFormSubmitSurveyInformation,
  openModalUpdate,


}) => {
  useEffect(() => {
    gListFieldsActive()
  }, [])

  const pushLoading = useLoading()
  const pushToast = useToast();
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)
  const { id, unitTemp } = useSelector(selectorInfoUser) // đợn vị dc chọn

  const [isSettingShow, setSettingShow] = useState(false)
  const [loadingTableDetail, setLoadingTableDetail] = useState(false)

  const [activeTab, setActiveTab] = useState<PaginationKey>("info");
  const [dataFieldsSurveyInformationActive, setDataFieldsSurveyInformationActive] = useState<IDataFilterActive>(EMPTY_GROUP);
  const [dataFieldsSurveyInformationNoActive, setDataFieldsSurveyInformationNoActive] = useState<IDataFilterNoActive>(EMPTY_GROUP);
  const [columnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([]);
  const [paginationMap, setPaginationMap] = useState<Record<PaginationKey, IPagination>>({
    info: { current: 1, pageSize: 10, total: 0 },
  });
  const [loadedTabs, setLoadedTabs] = useState<Record<PaginationKey, boolean>>({
    info: false,
  });

  const [selectId, setSelectId] = useState<number>()
  const [infoSurveyInformation, setInfoSurveyInformation] = useState<ICustomer[]>([]);
  const [infoQuestionSurvey, setInfoQuestionSurvey] = useState<IQuestionSurvey[]>([]);

  //#region Cấu hình cột
  const actionColumn: ColDef = {
    headerName: 'Hành động',
    field: 'action',
    colId: 'action',
    width: 160,
    resizable: false,
    suppressMovable: true,
    lockPosition: 'left',
    headerComponentParams: {
      template: '<span class="w-full flex items-center justify-center">Hành động</span>'
    },
    cellRenderer: (params: any) => {
      const { id } = params?.data
      return (
        <div className='d-flex gap-2 justify-center align-center  h-full px-1'>
          <EyeOutlined
            className='text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer'
            onClick={(e) => {
              e.stopPropagation(); // 🔴 chặn click lan lên row
              const currentId = params.data?.id;
              if (!currentId) {
                pushToast("không tồn tại id!", 'error')
                return
              }
              if (currentId === selectId) {
                params.node.setSelected(false); // ❌ bỏ chọn
                setSelectId(undefined);         // reset
                return;
              }

              params.node.setSelected(true);    // ✅ chọn mới
              setSelectId(currentId);
            }}
          />

          <EditOutlined
            className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer `}
            onClick={() => openModalUpdate(id)}
          />
        </div>

      )
    },
  }
  const memoizedColumnDefs = useMemo(() => {
    return generateColumnsFromCodesAgGridReactRecordCar(
      columnsMapShow,
      dataFieldsActive,
      actionColumn, // actionColumn
      undefined, // onToggleStatus
      { setDataFilterList: () => { } }, // headerActions
      undefined, // listFilterIcon
      undefined, // dataFilterList
      idCustomer, // customerId
      ["contact_name"] // listFieldCodeLink
    );
    // return generateColumnsFromCodesAgGridReactRecordCar(
    //   columnsMapShow, dataFieldsActive, actionColumn,
    //   () => { }
    // );
  }, [columnsMapShow, dataFieldsActive, selectId]);

  const tableData = useMemo(() => {
    return data.map((item) => {
      const fieldValues = item.fields.reduce((acc: Record<string, any>, field) => {
        acc[field.fieldCode] = field.view === false ? NO_VIEW : field.value;
        return acc;
      }, {});

      return {
        ...item,
        key: item.id.toString(),
        ...fieldValues
      };
    });
  }, [data]);

  useEffect(() => {
    const codes = dataFieldsActive.map((f) => f.fieldCode);
    setColumnsMapShow(codes);
  }, [dataFieldsActive]);
  //#endregion

  const gListFieldsActive = async () => {
    const [surveyInformationTabDetailRes] =
      await Promise.all([
        getListFieldsByCustomer(FIELDTYPE.SurveyInformationDetail, 1),
      ]);
    const flattenedFieldsContactInformation = flattenFields(surveyInformationTabDetailRes?.data ?? []);

    setDataFieldsSurveyInformationActive({
      info: flattenedFieldsContactInformation,

    });

    gListFieldsNotActive();
  };

  const gListFieldsNotActive = async () => {
    const [surveyInformationTabDetailNoActiveRes] =
      await Promise.all([
        getListFieldsByCustomer(FIELDTYPE.SurveyInformationDetail, 0),
      ]);

    setDataFieldsSurveyInformationNoActive({
      info: surveyInformationTabDetailNoActiveRes?.data ?? [],
    })
  };


  const gInfoQuestionSurvey = async (id: number) => {
    pushLoading(true)
    // const result = await getInfoQuestionSurvey(surveyId)
    const result = await getInfoQuestionSurvey(id)
    if (result?.status) {
      setInfoQuestionSurvey(result.data)
      setIsModalSurveyInformationDetail(true)

    } else {
      pushToast(result?.message, "warning")
    }
    // 🔥 QUAN TRỌNG
    setLoadedTabs(prev => ({
      ...prev,
      info: true,
    }));
    pushLoading(false)
  }


  const gListDetail = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {

    if (!idCustomer || !selectId) {
      setInfoSurveyInformation([]);
      return;
    }
    setLoadingTableDetail(true)
    const result = await getListCustomerSurvey(
      idCustomer, unitTemp, permittedCategoryCarIds,
      selectId, pageSize, pageCurent
    )
    if (result?.status) {
      setInfoSurveyInformation(result.data)
      setPaginationMap(prev => ({
        ...prev,
        info: {
          current: pageCurent,
          pageSize,
          total: result.total,
        },
      }));
    } else {
      pushToast(result?.message, "warning")
    }
    // 🔥 QUAN TRỌNG
    setLoadedTabs(prev => ({
      ...prev,
      info: true,
    }));
    setLoadingTableDetail(false)
  }, 1000)

  const onSaveVisibleFields = useThrottle(async (dataFilterActive: FlattenedField[], dataFilterNoActive: ListField[]) => {
    let result: any;
    const activeFields: FieldsUpdate[] = dataFilterActive.map(item => ({
      fieldId: item.id,
      isActive: 1, // hoặc true tùy bạn muốn mặc định là gì
    }));
    const allFieldsDefaultInactive: FieldsUpdate[] = dataFilterNoActive.flatMap(group =>
      group.fields.map(field => ({
        fieldId: field.id,
        isActive: 0,
      }))
    );
    const listActiveFields = activeFields.concat(allFieldsDefaultInactive)

    switch (activeTab) {

      case 'info': {
        result = await updateFieldUser(id, FIELDTYPE.SurveyInformationDetail, undefined, listActiveFields)
        break;
      }

      default:
        break;
    }

    if (result?.status) {
      pushToast(result?.message, "success")
      setSettingShow(false)

      if (dataFilterActive && dataFilterNoActive) {
        setDataFieldsSurveyInformationActive(prev => ({
          ...prev,
          [activeTab]: dataFilterActive ?? [],
        }));

        setDataFieldsSurveyInformationNoActive(prev => ({
          ...prev,
          [activeTab]: dataFilterNoActive ?? [],
        }));
      }

    } else {
      pushToast(result?.message, "warning")
    }
  }, 2000)

  const onPaginationChangeTab: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    switch (activeTab) {
      case "info": {
        gListDetail(pageNumber, pageSize)
        break;
      }
      default:
        break;
    }
  }

  const resultFormSubmitUpdate = async (iSsuccess: boolean, message?: string) => {
    resultFormSubmitSurveyInformation?.(iSsuccess, message)
    if (iSsuccess) {
      switch (activeTab) {
        case "info": {
          if (selectId === infoSurveyInformationDetail?.carId)
            gListDetail(paginationMap.info.current, paginationMap.info.pageSize)
          break;
        }
        default:
          break;
      }
    }
    else {

    }
  }

  useEffect(() => {
    if (!selectId) {
      // 1️⃣ RESET
      setInfoSurveyInformation([]);
      return;
    }


    setLoadedTabs({
      info: false,
    });

    setPaginationMap({
      info: { current: 1, pageSize: 10, total: 0 },

    });

    // 2️⃣ GỌI API ĐÚNG TAB
    switch (activeTab) {
      case "info":
        gListDetail();
        break;
      default:
        break
    }
  }, [selectId]);

  useEffect(() => {
    if (!selectId) return;

    switch (activeTab) {
      case "info":
        if (!loadedTabs.info) gListDetail();
        break;
      default:
        break
    }
  }, [activeTab]);
  return (
    <>
      {
        isSettingShow ?
          <ServiceRecordFeilds
            isSettingShow={isSettingShow}
            type={0}
            dataFilterActive={dataFieldsSurveyInformationActive[activeTab]}
            dataFilterNoActive={dataFieldsSurveyInformationNoActive[activeTab]}

            onSaveVisibleFields={onSaveVisibleFields}
            onClose={() => setSettingShow(false)}
          /> :
          null
      }

      {/* Khảo sát */}
      <ModalSurveyInformationAdd
        isOpen={isModalModalSurveyInformationAdd}
        idCustomer={idCustomer}
        resultFormSubmit={resultFormSubmitSurveyInformation}
        closeModal={setIsModalSurveyInformationAdd}
      />

      <ModalSurveyInformationDetail
        isOpen={isModalModalSurveyInformationDetail}
        infoQuestionSurvey={infoQuestionSurvey}
        closeModal={setIsModalSurveyInformationDetail}
      />

      <ModalSurveyInformationUpdate
        isOpen={isModalModalSurveyInformationUpdate}
        idCustomer={idCustomer}
        infoSurveyInformationDetail={infoSurveyInformationDetail}
        resultFormSubmit={resultFormSubmitUpdate}
        closeModal={setIsModalModalSurveyInformationUpdate}
      />

      <div className="custom-page-css w-full flex flex-col items-center justify-between gap-3 ">
        <div className="ag-theme-alpine custom-table-ag custom-css-table"
          style={{ width: '100%', height: tableData.length === 0 ? 250 : tableData.length < 10 ? tableData.length * 65 + 65 : 650 }}
        >
          <AgGridReact
            className="my-auto-height-grid"
            getRowStyle={(params: any) => ({
              backgroundColor: params?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
            })}
            rowData={tableData}
            columnDefs={memoizedColumnDefs}
            rowHeight={55}
            overlayNoRowsTemplate={NodataTable}
            loading={loadingTable}
            loadingOverlayComponent={CustomLoadingOverlayTable}
            // onGridReady={(params) => {
            //   params.api.sizeColumnsToFit();
            // }}

            /* Selection – CHỈ CHO PHÉP SELECT BẰNG CODE */
            rowSelection="single"
            suppressRowClickSelection={true}

            /* Performance */
            suppressColumnVirtualisation={true}
            suppressRowVirtualisation={false}
            enableCellTextSelection={true}
            ensureDomOrder={true}
            debounceVerticalScrollbar={true}
            suppressScrollOnNewData={true}
            suppressDragLeaveHidesColumns={true}

            /* Scroll */
            rowBuffer={20}
            maxBlocksInCache={10}
            infiniteInitialRowCount={1000}
          />

        </div>
        <ConfigProvider
          locale={viVN}
        >
          <div className="pagination-block">
            <Pagination
              showSizeChanger
              current={pagination.current}
              pageSize={pagination.pageSize}
              total={pagination.total}
              itemRender={(page, type, originalElement) => {
                // Chỉ custom khi là nút số trang
                if (type === 'page') {
                  return <span>{formatNumber(page)}</span>;
                }
                // prev / next / jump-prev / jump-next giữ nguyên
                return originalElement;
              }}
              showTotal={() =>
                `Tổng cộng ${dataPagination(
                  pagination.total,
                  pagination.pageSize,
                  pagination.current
                ).totalPage} trang`
              }
              className="rs-pagination"
              onChange={onPaginationChange}
            />
          </div>
        </ConfigProvider>
        {/* {
          selectId ? ( */}
        <div
          className="custom-page-css w-full flex items-center justify-between gap-3 pt-3 relative"
        >
          <Tabs
            className='w-full'
            activeKey={activeTab}

            items={[
              {
                key: 'info',
                label: <span className='custom-page-css font-light text-lg'>Chi tiết</span>,
                children:
                  <TabSurveyInformationTabDetail
                    loadingTableDetail={loadingTableDetail}
                    dataFieldsActive={dataFieldsSurveyInformationActive.info}
                    pagination={paginationMap.info}
                    data={infoSurveyInformation}
                    gInfoQuestionSurvey={gInfoQuestionSurvey}
                    onPaginationChange={onPaginationChange}

                  />

                ,
              },
            ]}
          />
          <div className="custom-page-css absolute top-4 right-0">
            <div className='settingCol'>
              <div className='ctr-col-setting'
                onClick={() => setSettingShow(true)}
              >
                <SettingOutlined />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default TabSurveyInformation